import { colors } from 'styles/colors';
import styled from 'styled-components';

export const columnWidth = '680px';

export const HindisvikWrapper = styled.div`
  padding: 4rem 0;

  h1,
  h2 {
    margin-bottom: 2rem;
    font-size: 2.25rem;
    color: ${colors.ink};

    @media (min-width: 992px) {
      font-size: 2.75rem;
    }
  }
`;

// The text column every section shares, so the left edge of the text lines up down the page
export const Details = styled.div`
  max-width: ${columnWidth};
  margin: 0 auto;
  font-size: 1.125rem;
  line-height: 1.75em;
  color: ${colors.ink};

  @media (min-width: 992px) {
    font-size: 1.25rem;
  }
`;

// Full-width photo between sections
export const Photo = styled.figure`
  margin: 0;

  .gatsby-image-wrapper {
    width: 100%;

    @media (min-width: 768px) {
      height: 60vh;
      min-height: 360px;
      max-height: 640px;
    }
  }
`;

// Lines up with the text column
export const Caption = styled.figcaption`
  width: 90%;
  max-width: ${columnWidth};
  margin: 0.75rem auto 0;
  font-size: 0.9rem;
  line-height: 1.5;
  color: ${colors.muted};

  a {
    color: inherit;
    text-decoration: underline;
  }
`;

export const MapFigure = styled.figure`
  margin: 2.5rem 0 0;

  img {
    display: block;
    width: 100%;
    height: auto;
    margin: 0;
    border: 1px solid ${colors.seaLight};
    border-radius: 0.5rem;
  }

  figcaption {
    margin-top: 0.5rem;
    font-size: 0.85rem;
    line-height: 1.5;
    color: ${colors.muted};
  }

  a {
    color: inherit;
    text-decoration: underline;
  }
`;
